import ResultRowDesktopSkeleton from '../ResultRowDesktopSkeleton';

function ResultsSkeleton(): JSX.Element {
  return (
    <>
      <ResultRowDesktopSkeleton />
      <ResultRowDesktopSkeleton />
      <ResultRowDesktopSkeleton />
      <ResultRowDesktopSkeleton />
      <ResultRowDesktopSkeleton />
      <ResultRowDesktopSkeleton />
      <ResultRowDesktopSkeleton />
      <ResultRowDesktopSkeleton />
    </>
  );
}

export default ResultsSkeleton;
